import DuplicateModal from './DuplicateModal';

export default DuplicateModal;
